import createElement from '../utils/dom/createElement';
export function getNodeFromSelector(selector) {
    if (selector instanceof Element) {
        return selector;
    }
    if (typeof selector === 'string') {
        var node = document.querySelector(selector);
        if (node) {
            return node;
        }
    }
    throw new Error('Invalid selector');
}
export function createContainerNode(parent, tag) {
    if (tag === void 0) { tag = 'div'; }
    var div = createElement(tag);
    return parent.appendChild(div);
}
export function removeAllChildren(node) {
    while (node && node.firstChild) {
        node.removeChild(node.firstChild);
    }
}
export function hasScrollbarY(element) {
    if (element === document.body) {
        return element.scrollHeight > window.innerHeight;
    }
    return element.scrollHeight > element.clientHeight;
}
